import React from 'react';
import { withRouter } from 'react-router-dom'
import { Redirect } from 'react-router-dom';

const SetLocation = ({match, setLocationIntoCookie}) => {
    setLocationIntoCookie(match.params.locationCode);
    return <Redirect to='/' />
};

export default withRouter(SetLocation);